
const state = {
  show: false,
  bankInfo: {}
}

const actions = {
  updateBank (ctx, item) {
    ctx.commit('updateBank', item)
  }
}

const mutations = {
  updateBank (state, item) {
    state.bankInfo = item
  },
  showAddBank (state, item) {
    state.show = item
  }
}

export default{
  namespaced: true,
  state,
  actions,
  mutations
}
